import { VehicleModelConsts } from '../../../consts/vehicle-model.consts';
import { VehicleStateEnum } from '../../../consts/vehicle-state.enum';
import { InsuranceDataEnum } from '../../../consts/insurance-data.enum';
import { OwnerDataConsts } from '../../../consts/owner-data.consts';
import { AdditionalInformationSectionConsts } from '../../../../shared/sections/web/additional-information-section/additional-information-section.consts';
import { StepKey } from '../../../enums/step-key.enum';
import { logoUrl } from '../../../utils/utils';
import {ProductTileKey} from '../../../../shared/enums/product-tile-key.enum';
import {SalesChannel} from '../../../consts/sales-channel.enum';

export enum ElementVisibility {
  VISIBLE = 'VISIBLE',
  ONLY_MOBILE = 'ONLY_MOBILE',
  ONLY_DESKTOP = 'ONLY_DESKTOP',
  HIDDEN = 'HIDDEN',
  ORIGIN_WWW = 'ORIGIN_WWW',
  ORIGIN_NOT_MOBILE = 'ORIGIN_NOT_MOBILE',
}

export class InternalConfig {

  static additionalInfo = 'Pole uzupełnione automatycznie. W przypadku niepoprawnych danych, wprowadź je ponownie. Dane niewymagające korekty pozostaw bez zmian i przejdź dalej.';

  public static config = {
    KIOSKPOLIS: {
      headerConfig: {
        visible: ElementVisibility.VISIBLE,
        logo: {
          url: logoUrl(),
          visible: ElementVisibility.VISIBLE
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.ONLY_DESKTOP
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_DESKTOP
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.HIDDEN
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.VISIBLE
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_MOBILE
        },
        backButton: {
          visible: ElementVisibility.HIDDEN
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: false,
      otherProductsConfig: {
        enabled: true,
        urlSource: 'moto_thank_you_page',
        products: [
          {
            productKey: ProductTileKey.TRAVEL,
            endpoints: {
              dev: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails',
              test: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails',
              prod: 'https://kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails'
            }
          },
          {
            productKey: ProductTileKey.CDW,
            endpoints: {
              dev: 'https://dev.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details',
              test: 'https://test.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details',
              prod: 'https://kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details'
            }
          },
          {
            productKey: ProductTileKey.HOME,
            endpoints: {
              dev: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details',
              test: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details',
              prod: 'https://kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details'
            }
          }
        ]
      },
      accumulatedSectionsSteps: [
          StepKey.FIRST_STEP_0,
          StepKey.FIRST_STEP_1,
          StepKey.FIRST_STEP_2,
          StepKey.FIRST_STEP_3,
      ]
    },
    INTERCARS: {
      headerConfig: {
        visible: ElementVisibility.VISIBLE,
        logo: {
          url: './assets/images/logo/intercars_go.png',
          visible: ElementVisibility.VISIBLE
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.VISIBLE
        },
        offerNumber: {
          visible: ElementVisibility.VISIBLE
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.HIDDEN
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.VISIBLE
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        backButton: {
          visible: ElementVisibility.VISIBLE
        },
        collectedCarsAmount: {
          visible: ElementVisibility.VISIBLE
        }
      },
      filtersEnabled: false,
    },
    YANOSIK: {
      headerConfig: {
        visible: ElementVisibility.HIDDEN,
        logo: {
          url: '',
          visible: ElementVisibility.HIDDEN
        },
        title: {
          text: '',
          visible: ElementVisibility.HIDDEN
        },
        breadcrumb: {
          visible: ElementVisibility.VISIBLE
        },
        offerNumber: {
          visible: ElementVisibility.VISIBLE
        }
      },
      mainContentConfig: {
        header: {
          visible: ElementVisibility.ORIGIN_WWW,
          logo: {
            url: './assets/images/logo/yanosik-black.svg',
            visible: ElementVisibility.VISIBLE
          },
          title: {
            text: 'headerAlt',
            visible: ElementVisibility.VISIBLE
          },
          customerDamageData: {
            visible: ElementVisibility.VISIBLE
          }
        },
        breadcrumb: {
          visible: ElementVisibility.ONLY_DESKTOP
        },
        image: {
          url: '',
          visible: ElementVisibility.ONLY_DESKTOP
        },
        stepInfo: {
          visible: ElementVisibility.VISIBLE,
          stepCounter: {
            visible: ElementVisibility.VISIBLE
          }
        },
        backButton: {
          visible: ElementVisibility.ORIGIN_WWW
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: false,
      additionalNavigateConfig: {
        steps: [
          {
            stepKey: StepKey.FIRST_STEP_3,
            stepButtonLabel: 'next'
          }
        ]
      }
    },
    BANKIER: {
      headerConfig: {
        visible: ElementVisibility.VISIBLE,
        logo: {
          url: './assets/images/logo/kioskpolis-rgb.svg',
          visible: ElementVisibility.HIDDEN
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.VISIBLE
        },
        offerNumber: {
          visible: ElementVisibility.VISIBLE
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.HIDDEN
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.HIDDEN
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        backButton: {
          visible: ElementVisibility.VISIBLE
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: false,
    },
    OLX: {
      headerConfig: {
        visible: ElementVisibility.VISIBLE,
        logo: {
          url: './assets/images/logo/kioskpolis-olx.png',
          visible: ElementVisibility.VISIBLE
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.ONLY_DESKTOP
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_DESKTOP
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.ONLY_MOBILE
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.VISIBLE
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_MOBILE
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        backButton: {
          visible: ElementVisibility.VISIBLE
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: false,
    },
    MPAY: {
      headerConfig: {
        visible: ElementVisibility.ORIGIN_NOT_MOBILE,
        logo: {
          url: logoUrl(),
          visible: ElementVisibility.VISIBLE
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.ONLY_DESKTOP
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_DESKTOP
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_MOBILE
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        backButton: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        }
      },
      sectionsVisibilityConfig: {
        aztecSection: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        salesMessagesSection: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        additionalContentSection: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: true,
    },
    SKYCASH: {
      headerConfig: {
        visible: ElementVisibility.ORIGIN_NOT_MOBILE,
        logo: {
          url: logoUrl(),
          visible: ElementVisibility.VISIBLE
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.ONLY_DESKTOP
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_DESKTOP
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_MOBILE
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        backButton: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        }
      },
      sectionsVisibilityConfig: {
        aztecSection: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        salesMessagesSection: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        },
        additionalContentSection: {
          visible: ElementVisibility.ORIGIN_NOT_MOBILE
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: true,
    },
    CARONE: {
      headerConfig: {
        visible: ElementVisibility.VISIBLE,
        logo: {
          url: logoUrl(),
          visible: ElementVisibility.VISIBLE
        },
        additionalLogo: {
          url: './assets/images/logo/car-one.svg',
          visible: ElementVisibility.VISIBLE
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.ONLY_DESKTOP
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_DESKTOP
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.HIDDEN
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.VISIBLE
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_MOBILE
        },
        backButton: {
          visible: ElementVisibility.HIDDEN
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: false,
      otherProductsConfig: {
        enabled: true,
        urlSource: 'moto_thank_you_page',
        products: [
          {
            productKey: ProductTileKey.TRAVEL,
            endpoints: {
              dev: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails',
              test: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails',
              prod: 'https://kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails'
            }
          },
          {
            productKey: ProductTileKey.CDW,
            endpoints: {
              dev: 'https://dev.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details',
              test: 'https://test.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details',
              prod: 'https://kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details'
            }
          },
          {
            productKey: ProductTileKey.HOME,
            endpoints: {
              dev: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details',
              test: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details',
              prod: 'https://kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details'
            }
          }
        ]
      },
      accumulatedSectionsSteps: [
        StepKey.FIRST_STEP_0,
        StepKey.FIRST_STEP_1,
        StepKey.FIRST_STEP_2,
        StepKey.FIRST_STEP_3,
      ]
    },
    [SalesChannel.NESTBANK]: {
      headerConfig: {
        visible: ElementVisibility.VISIBLE,
        logo: {
          url: logoUrl(),
          visible: ElementVisibility.VISIBLE
        },
        title: {
          text: 'header',
          visible: ElementVisibility.VISIBLE
        },
        breadcrumb: {
          visible: ElementVisibility.ONLY_DESKTOP
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_DESKTOP
        }
      },
      mainContentConfig: {
        breadcrumb: {
          visible: ElementVisibility.HIDDEN
        },
        image: {
          url: './assets/images/icons/illustration-oc.svg',
          visible: ElementVisibility.VISIBLE
        },
        stepInfo: {
          visible: ElementVisibility.HIDDEN,
          stepCounter: {
            visible: ElementVisibility.HIDDEN
          }
        },
        offerNumber: {
          visible: ElementVisibility.ONLY_MOBILE
        },
        backButton: {
          visible: ElementVisibility.HIDDEN
        }
      },
      predefinedValues: {
        'VEHICLE_DATA_SECTION': {
          [VehicleStateEnum.ACTUAL_MILEAGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.AVG_MILEAGE_PER_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.USAGE_TYPE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.PARKING_PLACE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.IS_ABROAD]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.START_INSURANCE_DATE]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [InsuranceDataEnum.YOUNGEST_DRIVER_AGE]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleStateEnum.ABROAD_IMPORTED]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'VEHICLE_MODEL_SECTION': {
          [VehicleModelConsts.VEHICLE_CODE_EUROTAX]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [VehicleModelConsts.VEHICLE_CODE_INFOEKSPERT]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.PHONE_NUMBER]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.EMAIL]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.MATRIMONIAL_STATUS]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
          [OwnerDataConsts.CHILDREN_UNDER_26]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'CO_OWNER_DATA_SECTION': {
          [OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR]: {
            'isPredefined': true,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          },
        },
        'ADDITIONAL_INFORMATION_SECTION': {
          [AdditionalInformationSectionConsts.VIN]: {
            'isPredefined': false,
            additionalInfo: {
              pl: InternalConfig.additionalInfo
            }
          }
        }
      },
      filtersEnabled: false,
      favicon: './assets/images/favicons/nestbank-favicon.svg',
      otherProductsConfig: {
        enabled: true,
        urlSource: 'moto_thank_you_page',
        products: [
          {
            productKey: ProductTileKey.TRAVEL,
            endpoints: {
              dev: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails',
              test: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails',
              prod: 'https://kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/?stepKey=travelDetails'
            }
          },
          {
            productKey: ProductTileKey.CDW,
            endpoints: {
              dev: 'https://dev.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details',
              test: 'https://test.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details',
              prod: 'https://kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/?stepKey=details'
            }
          },
          {
            productKey: ProductTileKey.HOME,
            endpoints: {
              dev: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details',
              test: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details',
              prod: 'https://kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/?stepKey=details'
            }
          }
        ]
      },
      accumulatedSectionsSteps: [
        StepKey.FIRST_STEP_0,
        StepKey.FIRST_STEP_1,
        StepKey.FIRST_STEP_2,
        StepKey.FIRST_STEP_3,
      ]
    }
  }
}
